
import React, { useRef, useEffect, useState } from 'react';
import { createMuiTheme, ThemeProvider, makeStyles } from "@material-ui/core/styles";
import { lightBlue, deepOrange } from '@material-ui/core/colors';
import { CircularProgress, AppBar, CssBaseline, Typography, Paper, Grid, Button, Divider, Card, CardContent, List, ListItem, Snackbar, ListItemText, ListItemAvatar, Avatar, Backdrop } from "@material-ui/core";

import MuiAlert from '@material-ui/lab/Alert';
import { AlertTitle, Alert } from '@material-ui/lab';
import axios from 'axios';
import { Heading } from "grommet";

import Webcam from "react-webcam";
import * as cocossd from "@tensorflow-models/coco-ssd";

import "@tensorflow/tfjs";
import '@tensorflow/tfjs-core';
// Adds the CPU backend to the global backend registry.
import '@tensorflow/tfjs-backend-cpu';

import BottleImg from "./images/bottle.png";
import bagImg from "./images/bag.png";
import compImg from "./images/compost.png";

const palletType = "dark"
const mainPrimaryColor = lightBlue[500];
const mainSecondaryColor = deepOrange[500];

const darkTheme = createMuiTheme({
  palette: {

    type: palletType,
    primary: {
      main: mainPrimaryColor,
    },
    secondary: {
      main: mainSecondaryColor
    },
  },
  typography: {
    fontSize: "15px",
    fontFamily: [
      'monospace',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
});


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: theme.spacing(1),
    left: 0,
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',

  },
  title: {
    fontSize: 34,
    alignSelf: "center",
    textAlign: "center"
  },
  listitem: {
    background: "#303030",
    color: "white",
    borderRadius: '10px',
    marginTop: "10px",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const App = () => {

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const [open, setOpen] = React.useState(false);

  //HARDWARE WITH BACKEND ON - COMMENT THIS OUT IF YOU WANT TO DO THE BACKEND
/*   const sendRecycleData = async () => {
    return axios.post('http://localhost:8351/api/v1/post/recycle', {
      uuid: 'Test'
    })
      .then((data) => {
        setOpen(true);
      }, (error) => {

      });

  }
  const sendGarbageData = async () => {
    return axios.post('http://localhost:8351/api/v1/post/garbage', {
      uuid: 'Test'
    })
      .then((data) => {
        setOpen(true);
      }, (error) => {

      });

  }
  const sendCompostData = async () => {
    return axios.post('http://localhost:8351/api/v1/post/compost', {
      uuid: 'Test'
    })
      .then((data) => {
        setOpen(true);
      }, (error) => {

      });

  } */

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const recycleStuff = ['bottle', 'book'];
  const garbageStuff = ['cup', 'fork', 'spoon', 'chair'];
  const compStuff = ['banana', 'apple', 'orange', 'sandwich', 'carrot'];

  const scannedItems = new Set([])

  const classes = useStyles();
  const [webcam, setWebCam] = useState(false);

  const enableWebcam = () => {
    setWebCam(true)
    runCoco()
    handleOpenBackDrop()
  }
  const disablWebcam = () => {
    setWebCam(false)
  }
  const webcamRef = useRef(null);
  const canvasRef = useRef(null);


  // Main function
  const runCoco = async () => {
    const net = await cocossd.load();
    console.log("Model Loaded");
    handleCloseBackDrop();
    setInterval(() => {
      detect(net);
    }, 200);
  };
  //console.log("BEFORE" + scannedItems)
  const detect = async (net) => {
    // Check data is available
    if (
      typeof webcamRef.current !== "undefined" &&
      webcamRef.current !== null &&
      webcamRef.current.video.readyState === 4
    ) {
      // Get Video Properties
      const video = webcamRef.current.video;
      const videoWidth = webcamRef.current.video.videoWidth;
      const videoHeight = webcamRef.current.video.videoHeight;

      // Set video width
      webcamRef.current.video.width = videoWidth;
      webcamRef.current.video.height = videoHeight;

      // Make Detections
      const obj = await net.detect(video);

      var textItem = '';
      //drawRect(obj, ctx);
      obj.forEach(prediction => {
        textItem = prediction['class'];
        if (recycleStuff.includes(textItem) && !scannedItems.has(textItem)) {
          setRecycleItems((prev) => {
            return [...prev, textItem]
          });
          setItem(""); 
          //sendRecycleData(); // UN-COMMENT THIS OUT IF USING BACK END
          setOpen(true); // COMMENT THIS OUT IF USING BACK END
          scannedItems.add(textItem)
        }
        if (garbageStuff.includes(textItem) && !scannedItems.has(textItem)) {
          setGarbageItem((prev) => {
            return [...prev, textItem]
          });
          setItem("");
          //sendGarbageData();// UN-COMMENT THIS OUT IF USING BACK END
          setOpen(true); // COMMENT THIS OUT IF USING BACK END
          scannedItems.add(textItem)
        }
        if (compStuff.includes(textItem) && !scannedItems.has(textItem)) {
          setCompItem((prev) => {
            return [...prev, textItem]
          });
          setItem("");
          setOpen(true); // COMMENT THIS OUT IF USING BACK END
          //sendCompostData(); // UN-COMMENT THIS OUT IF USING BACK END
          scannedItems.add(textItem)
        }
      });
      console.log(scannedItems)
    }
  };


  const [item, setItem] = useState("");
  const [garbageItems, setGarbageItem] = useState([]);
  const [recycleItems, setRecycleItems] = useState([]);
  const [compItems, setCompItem] = useState([]);
  const [openBackDrop, setBackDrop] = useState(false);

  const handleCloseBackDrop = () => {
    setBackDrop(false);
  };
  const handleOpenBackDrop = () => {
    setBackDrop(!open);
  };

  const restUI = () => {
    setGarbageItem([])
    setRecycleItems([])
    setCompItem([])
    scannedItems.clear();
  };
  return (
    <ThemeProvider theme={darkTheme}>
      <AppBar color="inherit">
        <Typography style={{ fontSize: "34px", alignSelf: "center", height: "10%", padding: "20px 20px 20px" }} variant="h3">🗑️ TRASH SORTER 🗑️</Typography>
      </AppBar>
      <CssBaseline />
      <Backdrop className={classes.backdrop} open={openBackDrop}>
        <CircularProgress color="inherit" /><Divider></Divider>
        <Paper style={{ fontSize: "28px", color: "#303030", background: "white" }} className={classes.paper}>
          Loading Models...
        </Paper>
      </Backdrop>
      <Typography style={{ marginTop: 100, marginLeft: 20 }}>
        <div className={classes.root}>
          <Grid justify="space-between" container spacing={1} direction="row">
            <Grid item spacing={3} container xs={12}>
              {/* START/STOP */}
              <Grid item xs={12} sm={6}>
                <Paper style={{ color: "#303030", background: "#f7d794" }} className={classes.paper}>
                  <Paper style={{ fontSize: "28px", color: "white", background: "#303030" }} className={classes.paper}>
                    About Trash Sorter
                  </Paper>
                  <Paper style={{ margin: "10px 0px 10px 0px", padding: "20px", fontSize: "14x", color: "white" }}>
                    <strong>Are you tired of seeing trash everywhere? Do you want to see a change in the world?</strong> Well, this is the right spot to start! Our project allows for the sorting of common waste. By utilizing Machine Learning through TensorFlow, we can easily detect if the object is categorized as trash. Using React.js as our Front-End and Node.js for the backend,  we have developed a cutting edge solution to this environmental problem. Using the power of Arduino, we have implemented seamless communication between our web application and backend to turn on LEDs for corresponding trash  (Recycle, Garbage, Compost).
                  </Paper>
                  <Grid item container xs={12}>
                    <Grid item xs={12} sm={12} direction="row">
                      <div>
                        {webcam == true ? (
                          <Paper style={{ color: "white", background: "#303030" }} className={classes.paper}>
                            <div className={classes.root}>

                              <Button variant="contained" color="secondary" onClick={disablWebcam}>
                                Stop
                              </Button>
                              <Button variant="contained" color="primary" onClick={restUI}>
                                Reset
                          </Button>
                            </div>
                          </Paper>
                        ) : (
                            <Paper style={{ color: "white", background: "#303030" }} className={classes.paper}>
                              <Alert style={{ fontSize: "20px"}} severity="info">Start using our Trash sorter by clicking start!</Alert>
                            </Paper>
                          )}
                        {/* ... */}
                      </div>
                    </Grid>
                  </Grid>
                </Paper>
                <Grid fill item spacing={1} container xs={12}>
                  {/* Recycle */}
                  <Grid item xs={12} sm={4} direction="row">
                    <Card className={classes.root} variant="outlined">
                      <CardContent>
                        <Typography style={{ fontSize: '20px' }} className={classes.title} color="white">
                          ♻️ Recycling
                 </Typography>
                      </CardContent>
                    </Card>
                    <Paper style={{ color: "#303030", background: "#0984e3" }} className={classes.paper}>
                      <div style={{ margin: '10px 5px ' }}>
                        <center>
                          {
                            recycleItems.map((val) => {
                              return (<List style={{ maxHeight: '100%', overflow: 'auto' }} className={classes.root}>
                                <ListItem alignItems="flex-start" className={classes.listitem}>
                                  <ListItemAvatar>
                                    <Avatar style={{ paddingBottom: "8px" }} alt="B" src={BottleImg} />
                                  </ListItemAvatar>
                                  <ListItemText style={{ fontSize: "25px", paddingTop: "1px", }}
                                    primary={val}
                                  />
                                </ListItem>
                              </List>)
                            })
                          }
                        </center>
                      </div>
                    </Paper>
                  </Grid>
                  {/* garbage */}
                  <Grid item xs={12} sm={4} direction="row">
                    <Card className={classes.root} variant="outlined">
                      <CardContent>
                        <Typography style={{ fontSize: '20px' }} className={classes.title} color="white">
                          🗑️ Garbage
                 </Typography>
                      </CardContent>
                    </Card>
                    <Paper style={{ color: "#303030", background: "#e74c3c" }} className={classes.paper} >
                      <div style={{ margin: '10px 5px ' }}>
                        <center>
                          {
                            garbageItems.map((val) => {
                              return (<List style={{ maxHeight: '100%', overflow: 'auto' }} className={classes.root}>
                                <ListItem alignItems="flex-start" className={classes.listitem}>
                                  <ListItemAvatar>
                                    <Avatar style={{ paddingBottom: "8px" }} alt="Garbage" src={bagImg} />
                                  </ListItemAvatar>
                                  <ListItemText style={{ fontSize: "25px", paddingTop: "1px" }}
                                    primary={val}
                                  />
                                </ListItem>
                              </List>)
                            })
                          }
                        </center>
                      </div>
                    </Paper>
                  </Grid>
                  {/* bio */}
                  <Grid item xs={12} sm={4}>
                    <Card className={classes.root} variant="outlined">
                      <CardContent>
                        <Typography style={{ fontSize: '20px' }} className={classes.title} color="white">
                        🍌 Compost
                 </Typography>
                      </CardContent>
                    </Card>
                    <Paper style={{ color: "#303030", background: "#27ae60" }} className={classes.paper}>
                      <div style={{ margin: '10px 5px ' }}>
                        <center>
                          {
                            compItems.map((val) => {
                              return (<List style={{ maxHeight: '100%', overflow: 'auto' }} className={classes.root}>
                                <ListItem alignItems="flex-start" className={classes.listitem}>
                                  <ListItemAvatar>
                                    <Avatar style={{ paddingBottom: "8px" }} alt="compost icon" src={compImg} />
                                  </ListItemAvatar>
                                  <ListItemText style={{ fontSize: "25px", paddingTop: "1px", }}
                                    primary={val}
                                  />
                                </ListItem>
                              </List>)
                            })
                          }
                        </center>
                      </div>
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
              {/* Camera */}
              <Grid fill item xs={12} sm={6}>
                <Paper style={{ color: "#303030", background: "#00FFC2" }} className={classes.paper}>
                  <div>
                    {webcam ? (
                      <div className={classes.root}>
                        <Webcam
                          ref={webcamRef}
                          muted={true}
                          style={{
                            position: "relative",
                            marginLeft: "auto",
                            marginRight: "auto",
                            left: 0,
                            right: 0,
                            textAlign: "center",
                            zindex: 9,
                            width: '100%',
                            height: 'auto',
                          }}
                        />
                      </div>
                    ) : (
                        <Paper style={{ color: "#303030", background: "#303030" }} className={classes.paper}>
                          <Button variant="contained" color="primary" onClick={enableWebcam}>
                            Start
                      </Button>
                        </Paper>
                      )}
                    {/* ... */}
                  </div>
                </Paper>
              </Grid>
            </Grid>

          </Grid>
        </div>
      </Typography>
      <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
        <Alert style={{ fontSize: '30px' }} onClose={handleClose} severity="success">
          Item Has been added and transmitted!
        </Alert>
      </Snackbar>
    </ThemeProvider >
  );
};

export default App;
